import { useContext, useState } from 'react';
import { GlobalsContext } from '../../../../components/Context/globalsContext';
import LargeFirmWelcome from './welcome';
import LargeFirmEvent from './event';
import LargeFirmResourceLibrary from './resourceLibrary';
import LargeFirmAboutUs from './aboutUs';
import MarketingNavigation from '../../../../navigation/marketing';
import { Button, Tab, Tabs, Typography } from '@mui/material';

export default function LargeFirmHome() {
    const { update: updateGlobals, state: globalsContext } = useContext(GlobalsContext);
    const [pageUrl, setPageUrl] = useState('welcome');
    const tabs = [
        { value: 'welcome', label: 'Welcome' },
        { value: 'events', label: 'Events' },
        { value: 'resource_library', label: 'Resource Library' },
        { value: 'about_us', label: 'About Us' },
    ];

    const renderHtml = (htmlTag) => {
        return { __html: htmlTag };
    };

    const handleChange = (event, newValue) => {
        setPageUrl(newValue);
    };

    const renderPage = (page) => {
        switch (page) {
            case 'welcome':
                return <LargeFirmWelcome></LargeFirmWelcome>;
            case 'events':
                return <LargeFirmEvent></LargeFirmEvent>;
            case 'resource_library':
                return <LargeFirmResourceLibrary></LargeFirmResourceLibrary>;
            case 'about_us':
                return <LargeFirmAboutUs></LargeFirmAboutUs>;
            default:
                return <></>;
        }
    };

    return (
        <div>
            {globalsContext && (
                <MarketingNavigation>
                    <div className='lpl-page bg-disabled-50'>
                        <div className='bg-primary-500 h-[300px] flex items-center'>
                            <div className='ml-16 p-4'>
                                <Typography variant='h1' className='text-white'>
                                    {globalsContext?.globals?.title}
                                </Typography>

                                <Typography variant='body1' className='text-white' dangerouslySetInnerHTML={renderHtml(globalsContext?.globals?.subTitle)}></Typography>
                            </div>
                        </div>

                        <div className='bg-white border px-5 py-6 rounded-xl border-solid border-primary-100 shadow m-5'>
                            {/* <div className='flex gap-4'>
                                {tabs.map((tab) => (
                                    <Button variant='outlined' color={pageUrl === tab.value ? 'secondary' : 'white'} key={tab.value} onClick={() => setPageUrl(tab.value)}>
                                        {tab.label}
                                    </Button>
                                ))}
                            </div> */}
                            <Tabs value={pageUrl} onChange={handleChange} variant='scrollable' scrollButtons='auto'>
                                <Tab label='Welcome' value='welcome' />
                                <Tab label='Events' value='events' />
                                <Tab label='Resource Library' value='resource_library' />
                                <Tab label='About Us' value='about_us' />
                            </Tabs>
                            <div className='mt-6'>{renderPage(pageUrl)}</div>
                        </div>
                    </div>
                </MarketingNavigation>
            )}
        </div>
    );
}
